module.exports = __webpack_public_path__ + "static/media/lock.33cec88d.svg";